<template>
<v-container
  fluid
>
  <v-row>
    <v-col
      cols="12"
    >
      <v-tabs
      >
        <v-tab>
          Verwalten
        </v-tab>
        <v-tab
          v-if="$store.getters.has_permission(['Kentix_Logbuch_r'])"
        >
          Logbuch
        </v-tab>
        <v-spacer></v-spacer>
        <v-tab
          v-if="$store.getters.has_permission(['Kentix_rw'])"
        >
          <v-icon
          >
            mdi-cogs
          </v-icon>
        </v-tab>
        <v-tab-item>
          <ls-manage></ls-manage>
        </v-tab-item>
        <v-tab-item
          v-if="$store.getters.has_permission(['Kentix_Logbuch_r'])"
        >
          <ls-logbook></ls-logbook>
        </v-tab-item>
        <v-tab-item>
          <ls-settings></ls-settings>
        </v-tab-item>
      </v-tabs>
    </v-col>
  </v-row>
</v-container>
</template>

<script>
import LsManage from "../components/LockingSystem/ls-manage";
import LsLogbook from "../components/LockingSystem/ls-logbook";
import LsSettings from "../components/LockingSystem/ls-settings.vue";
export default {
  name: "LockingSystem",
  components: { LsSettings, LsLogbook, LsManage },
  data: () => ({

  }),
  methods: {

  },

  mounted() {
    if (this.$store.state.kentix.users === null) {
      this.$store.dispatch("update", { "context": "/kentix/levelprofiles"})
      this.$store.dispatch("update", { "context": "/kentix/devices"})
      this.$store.dispatch("update", { "context": "/kentix/users"})
    }
  }
};
</script>

<style scoped>

</style>
